import { useQuery } from '@tanstack/react-query';

import { campaignsService, CampaignValueCards } from '@aslanpay/portal-common-lib';

const useFetchCampaignValueCards = (campaignId: string | undefined, enabled = true) => {
  return useQuery<CampaignValueCards, Error>(
    ['fetchCampaignValueCards', campaignId],
    () => campaignsService.fetchCampaignValueCards(campaignId as string),
    { enabled: enabled && !!campaignId }
  );
};

export default useFetchCampaignValueCards;
